import React from 'react';

// Helper function to format dates
const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

const ScheduleDownloadTable = ({ year, month, holidaysInMonth, getSingleUserData, holiday }) => {
  const daysInMonth = new Date(year, month, 0).getDate(); // Get number of days in the month

  // Function to check if a date is a holiday
  const isHoliday = (date) => holidaysInMonth && holidaysInMonth[formatDate(date)];

  return (
    <table className="table table-bordered holiday_table">
      <tbody>
        {Array.from({ length: daysInMonth }).map((_, i) => {
          const day = i + 1;
          const dateStr = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

          // Filter work items for the current date
          const workItems = getSingleUserData?.work_list?.filter(item => item.work_date === dateStr) || [];
          // Extract unique time slots (avoiding duplicates)
          const uniqueTimes = Array.from(
            new Set(workItems.map(workItem =>
              `${workItem.work_start_datetime?.slice(11, 16) || ''} ${workItem.work_start_datetime && workItem.work_end_datetime ? ' ～ ' : ''
              }${workItem.work_end_datetime?.slice(11, 16) || ''}`
            ))
          );

          const isWeekend = new Date(dateStr).getDay() === 0 || new Date(dateStr).getDay() === 6;
          const isHolidayDay = isHoliday(dateStr);

          return (
            <tr key={dateStr}>
              {/* Date Column with Work Time */}
              <td width={300}>
                <a href={`/scheduleList/${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`}>
                  {month}/{String(day).padStart(2, '0')}
                </a>
                &nbsp;
                <span style={{ fontWeight: 'bold' }}>
                  ({['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][new Date(dateStr).getDay()]})
                </span>

                {/* Show unique work start & end times */}
                {uniqueTimes.map((time, index) => (
                  <div key={index}>{time}</div>
                ))}
              </td>

            <td className={`${isWeekend || isHolidayDay ? 'box_color' : ''}`}  style={{textAlign : 'left'}}>
                {workItems.length > 0 ? (
                  workItems
                    .slice() // Avoid mutating the original array
                    .sort((a, b) => {
                      const isAZero = a.t_project_id === 0 && a.t_client_id === 0;
                      const isBZero = b.t_project_id === 0 && b.t_client_id === 0;
                      return isBZero - isAZero; // Move (0,0) items to the top
                    })
                    .map((workItem, index, sortedArray) => {
                      // If the first item satisfies (0,0), set index to 0, otherwise start from 1
                      const actualIndex = index === 0 && workItem.t_project_id === 0 && workItem.t_client_id === 0
                        ? 0
                        : sortedArray[0].t_project_id === 0 && sortedArray[0].t_client_id === 0
                          ? index // Ensure continuous numbering
                          : index + 1;

                      return (
                        <div key={`task-${workItem.id}-${index}`} className="task_detail_list">
                          <span className="task_detail" style={{ margin: '5px 0px 5px 5px', }}>
                            <em>{actualIndex}.</em> {/* Correct index logic */}
                            {workItem.t_client_id !== 0 && workItem.name_abbreviation && (
                              <span>[{workItem.name_abbreviation}]</span>
                            )}
                            <span>{workItem.project_name_abbreviation}</span>
                            <span style={{ color: '#9dad01', fontWeight: 'bold' }}>
                              {workItem.progress_rate !== '0' && workItem.progress_rate ? `[${workItem.progress_rate}%]` : null}
                            </span>
                            {holiday?.filter(
                              (val) =>
                                val.cd === workItem.holiday_cd.toString() &&
                                workItem.t_project_id === 0 &&
                                workItem.t_client_id === 0
                            ).map((value) => value.code_value1)}
                          </span>
                          <div className="comment" style={{ whiteSpace: "pre-line" }}>
                            <div>{workItem.task_detail}</div>
                          </div>
                        </div>
                      );
                    })
                ) : (
                  <>
                    {/* Holiday Column Show Here */}
                    {holidaysInMonth && holidaysInMonth[formatDate(dateStr)] && (
                      <div style={{ fontWeight: 'bold' }}>
                        {holidaysInMonth[formatDate(dateStr)]}
                      </div>
                    )}
                  </>
                )}
              </td>

              {/* Memo Column */}
              <td className={` ${isWeekend || isHolidayDay ? 'box_color' : ''}`}  style={{textAlign : 'left'}}>
                {workItems.map((workItem,index) => (
                    workItem.daily_memo && (
                      <div key={`meme-${workItems.id}-${index}`} className="comment" style={{ whiteSpace: "pre-line" }}>
                        {workItem.daily_memo}
                      </div>
                    )
                  ))}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ScheduleDownloadTable;
